module.exports = __webpack_public_path__ + "static/media/acti.5eae8648.gif";